// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"87":"82d0b414","97":"35a27db5","215":"49fd425d","252":"77da2b3d","406":"12cbc558","444":"102582a8","577":"b6c14b80","870":"7f130f91","881":"938dee43"}[chunkId] + ".chunk.css";
};